export default "__VITE_ASSET__RMxTKYEO__"